import React from 'react';
import PropTypes from 'prop-types';
import DashboardLayout from '../shared/Dashboard';

const AdminDashboard = ({ user, handleLogout }) => (
  <DashboardLayout user={user} handleLogout={handleLogout}>
    <p>
      Welcome,
      {user?.name}
      !
    </p>
  </DashboardLayout>
);

AdminDashboard.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  handleLogout: PropTypes.func.isRequired,
};
export default AdminDashboard;
